<template>
  <a
    class="btn-white"
    :href="href"
    :target="target"
  >
    {{ label }}
  </a>
</template>

<script>
  export default {
    props: {
      href: {
        type: String,
        required: true,
        default: '#'
      },
      target: {
        type: String,
        required: false,
        default: '_self'
      },
      label: {
        type: String,
        required: true
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  .btn-white {
    background: white;
    margin: 7px 0 5px 0;
    height: 48px;
    width: 100%;
    border: 1px solid #D7D7E9;
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 rgba(184, 184, 184, 0.5);
    align-items: center;
    display: flex;
    justify-content: center;
    text-decoration: none;
    color: #313892;
    font-size: em(14);
    font-weight: 500;
    line-height: 16px;
    text-align: center;
    transition: $linearTransition03;
    padding: 10px;

    &:hover {
      border: 1px solid #B1B1D2;
    }

    @include bp-mf-tablet {
      box-shadow: none;
    }
  }
</style>
